<template>
  <img :class="iconClass ?? 'pay-method-icon'"
       v-b-tooltip.hover
       loading="lazy"
       onerror="this.onerror=null; this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAADUlEQVR4nGP4////fwAJ+wP+J1iKsQAAAABJRU5ErkJggg==';"
       :src="helper.payMethodIcon(method!)"
       :alt="helper.trans('pay_methods.' + method)"
       :title="helper.trans('pay_methods.' + method)"
  >
</template>

<script lang="ts">

import {defineComponent} from 'vue'
import {helper} from "@/service/CommonHelper";

export default defineComponent({
  props: {
    method: String,
    iconClass: String
  },
  setup() {

    return {
      helper
    }
  }
})
</script>
